export { default as Listar } from './Listar';
export { default as FormRegistro } from './FormRegistro';



// WEBPACK FOOTER //
// ./src/features/parametros-sistema/index.js